import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import App from './ui/App.jsx';
import './styles.css';

/**
 * StrictMode is ON deliberately: it double-mounts every effect in dev, which is
 * exactly the pressure that catches non-idempotent `Engine.dispose()` and
 * leaked GPU resources. Do not remove it to "fix" a double-init bug — fix the
 * lifecycle instead.
 */
createRoot(document.getElementById('root')).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
